<template>
	<div class="wms-cell-operate">
		<span class="text-link" :style="style(item, params)" v-if="!judgeHide(item, params)" :class="{'wms-operate-disabled': judgeDisable(item, params), 'wms-operate-normal': judgeNormal(item, params)}" href="javascrip:void(0)" v-for="item in params.colDef.cellOperate" @click="click(item, params)">{{itemName(item, params)}}</span>
	</div>
</template>
<script>
import Vue from 'vue'
import store from '../../../store'
import {mapGetters} from 'vuex'
import  {sentBossService} from '../../../utils/utils'

export default Vue.extend({
	store,
	computed: {
		...mapGetters([
			'userName',
			'userId'
		])
	},
    methods: {
        style: (item, params) => {
            return _.isFunction(item.style) ? item.style(params) : item.style
        },
	    click(item, params) {
		    if (_.isFunction(item.disabled) && item.disabled(params)) {
			    return
		    }
		    sentBossService(this, this.itemName(item, params))
		    item.click(params)
	    },
        judgeDisable(item, params) {
            // 如果传入判断disable函数  按函数结果返回
            if (_.isFunction(item.disabled)) {
                return item.disabled(params)
            } else {
                // 未传入判断函数  默认可以点击
                return false
            }
        },
        judgeHide(item, params) {
            // 如果传入判断disable函数  按函数结果返回
            if (_.isFunction(item.hide)) {
                return item.hide(params)
            } else {
                // 未传入判断函数  默认可以点击
                return false
            }
        },
        judgeNormal(item) {
            //	是否只显示文本
            // 如果是  需手动在代码里写click的空处理
            return item.normal
        },
        itemName(item, params) {
            //	展示动态Name
            let res
            let name
            name = _.isFunction(item.name) ? item.name(params) : item.name
            res = item.showFiledName ? params.value : name
            return res
        }
    }
})
</script>
<style lang="less">
	@import "../../../styles/iview/custom.less";
	.wms-cell-operate {
		& > span {
			display: inline-block;
			padding: 0px 5px;
			border-right: 1px solid #c9ccdb;
			font-size: 12px;
			cursor: pointer;
			&:hover {
				text-decoration: underline;
			}
			&.wms-operate-disabled {
				cursor: not-allowed;
				color: @subsidiary-color;
				&:hover {
					text-decoration: none;
				}
			}
		}
		.text-link {
			color: @main-blue;
			&.wms-operate-normal {
				&:hover {
					text-decoration: none;
				}
				cursor: default;
				color: #495060;
			}
		}
	}
	.wms-cell-operate > span:last-child {
		border-right: 0px solid #c9ccdb;
	}
	.wms-cell-operate > span:last-child {
		border-right: 0px solid #c9ccdb;
	}
</style>
